import { RouteRecordRaw } from "vue-router";

export const surveyRoutes: RouteRecordRaw[] = [
  {
    path: "/surveys/:id/edit",
    name: "SurveyEdit",
    component: () => import("../views/SurveyEdit.vue"),
    meta: {
      requiresAuth: true,
      requiredModule: "survey",
      requiredRight: "viewUI",
    },
  },
];
